import script from "./AdditionalInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalInformation.vue?vue&type=script&setup=true&lang=ts"

import "./AdditionalInformation.vue?vue&type=style&index=0&id=55b86db6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b86db6"]])

export default __exports__